module.exports = __webpack_public_path__ + "static/media/camera_red_filled.dd96c805.svg";